// src/utils/abortWithTimeout.js
// Shared helper: create an AbortController that fires after `timeoutMs` OR
// when an optional `externalSignal` aborts, whichever comes first.
//
// Returns an AbortController with `_clearTimeout()` attached so callers can
// cancel the pending timer on success/failure to avoid dangling timers.

const DEFAULT_TIMEOUT_MS = 15000;

/**
 * @param {AbortSignal} [externalSignal]
 * @param {number} [timeoutMs=15000]
 * @returns {AbortController & { _clearTimeout: () => void }}
 */
export function abortWithTimeout(externalSignal, timeoutMs = DEFAULT_TIMEOUT_MS) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);

  if (externalSignal) {
    if (externalSignal.aborted) {
      clearTimeout(timer);
      controller.abort();
    } else {
      externalSignal.addEventListener('abort', () => {
        clearTimeout(timer);
        controller.abort();
      }, { once: true });
    }
  }

  controller._clearTimeout = () => clearTimeout(timer);
  return controller;
}
